import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslationsService } from './translations/translations.service';
import { NavigationEnd, Router } from '@angular/router';
import { RemoteDataService } from './remote-data.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ScrollService } from './scroll.service';
import { AnalyticsService } from './analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  public lang: string;
  isScrolled = false;
  menuOpen = false;
  private closeMobileNavSub: Subscription;

  constructor(
    public _translationsService: TranslationsService,
    private router: Router, private remoteDataService: RemoteDataService,
    private _scrollService: ScrollService,
    private analyticsService: AnalyticsService) {
  }

  ngOnInit() {
    this.remoteDataService.loadPosts();
    this.remoteDataService.loadIllustrations();

    document.documentElement.lang = this._translationsService.getLocal() === 'ru' ? 'ru' : 'en';

    this.analyticsService.initialize();

    if (typeof window !== 'undefined') {
      this.isScrolled = window.scrollY > 40;
    }

    this.closeMobileNavSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        if (typeof window === 'undefined' || !window.matchMedia('(max-width: 799px)').matches) {
          return;
        }
        this.closeMenu();
      });
  }

  ngOnDestroy(): void {
    this.closeMobileNavSub?.unsubscribe();
    this.unlockBodyScroll();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (typeof window === 'undefined') {
      return;
    }
    this.isScrolled = window.scrollY > 40;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    this.updateBodyScrollLock();
  }

  closeMenu(): void {
    if (!this.menuOpen) {
      return;
    }
    this.menuOpen = false;
    this.updateBodyScrollLock();
  }

  changeLang(val: string) {
    this._translationsService.setLocal(val);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = val === 'ru' ? 'ru' : 'en';
    }
    this.analyticsService.trackLanguageChange(val);
  }

  /** Runs after the routed component is in the DOM (correct timing vs NavigationEnd alone). */
  onRouteActivated(): void {
    this._scrollService.scrollToTopAfterRouteActivate();
  }

  private updateBodyScrollLock(): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.body.style.overflow = this.menuOpen ? 'hidden' : '';
  }

  private unlockBodyScroll(): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.body.style.overflow = '';
  }

}
